import React from 'react'
import { SubscriptionPlanPrice } from '../models/SubscriptionPlanPrice';
import { useTranslation } from 'react-i18next';

type Props = {
    price: SubscriptionPlanPrice;
    selectedId: number;
    onClick: () => void;
}

const PlanSelectRow = ({ price, selectedId, onClick }: Props) => {
    const { t } = useTranslation();

    function getClass() {
        if (selectedId === price.id) {
            return "border-solid border-[2px] border-primary-dark";
        }
        return "border-solid border-[2px] border-transparent hover:border-primary";
    }

    return (
        <div
            onClick={onClick}
            className={`bg-neutral-light  rounded-[8px] px-3 py-4 cursor-pointer flex justify-between shadow-md ${getClass()}`}>
            <div className="text-[18px]">
                {t(`payment.subscription_plans.${price.planId}`)}
            </div>
            <div className="text-[18px]">
                {price.priceGross.toLocaleString()} Ft/{t(`payment.subscription_interval_prices.${price.interval}`)}
            </div>
        </div>
    )
}

export default PlanSelectRow